var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.news) ? _c('div', {
    class: {
      'active': _vm.currentPage == _vm.page.news.$path
    },
    attrs: {
      "id": _vm.page.news.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.news.title
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "news-wrapper",
    class: {
      'static': _vm.isAnimated
    }
  }, [_c('div', {
    staticClass: "swiper-controls"
  }, [_c('div', {
    staticClass: "swiper-button-prev icon-arrow-left",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next icon-arrow-right",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })]), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    staticClass: "news-list",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.news.item), function(article, index) {
    return _c('swiper-slide', {
      staticClass: "article"
    }, [_c('span', {
      staticClass: "article__pointer",
      style: (("transition-delay: " + ((index * 200)/1000) + "s"))
    }), _vm._v(" "), _c('div', {
      staticClass: "article__inner",
      style: (("animation-delay: " + ((index * 200)/1000) + "s")),
      on: {
        "click": function($event) {
          _vm.setCurrentArticleID(index)
        }
      }
    }, [_c('div', {
      staticClass: "article__date"
    }, [(article.publication_datetime.$day) ? _c('span', {
      staticClass: "article__day"
    }, [_vm._v(_vm._s(_vm.setDay(article.publication_datetime.$day)))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "article__monthyear"
    }, [_c('span', {
      staticClass: "article__month"
    }, [_vm._v(_vm._s(_vm.$t('months', _vm.lang)[parseInt(article.publication_datetime.$month, 10) - 1]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.publication_datetime.$year))])])]), _vm._v(" "), _c('div', {
      staticClass: "article__summary",
      domProps: {
        "innerHTML": _vm._s(article.text.item.text_summary)
      }
    })])])
  }))], 1), _vm._v(" "), _c('NewsPopup')], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d240280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/News.vue
// module id = 188
// module chunks = 0